import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getHomeStatAssets } from "@/api/api-operation-service";
// import i18n from "@/config/i18n";
import homeDataBlock from "../home-data-block/home-data-block.vue";
import i18n from "@/config/i18n";
var AssetsType;
(function (AssetsType) {
    AssetsType["TOTAL"] = "total";
    AssetsType["DETAIL"] = "detail";
})(AssetsType || (AssetsType = {}));
let PiHomeDataBottom = class PiHomeDataBottom extends Vue {
    constructor() {
        super(...arguments);
        this.statAssets = {};
        this.type = AssetsType.TOTAL;
        this.loading = false;
        this.AssetsType = AssetsType;
        this.totalList = [
            {
                name: i18n.t("homeData.bottomSite"),
                value: 0,
                key: "staCount",
                unit: i18n.t("unitText.individual"),
                icon: require("../../img/accets/sta-num.png"),
            },
            {
                name: i18n.t("homeData.pileCount"),
                value: 0,
                key: "pileCount",
                unit: i18n.t("unitText.set"),
                icon: require("../../img/accets/pile-num.png"),
            },
            {
                name: i18n.t("homeData.bottomGun"),
                value: 0,
                key: "gunCount",
                unit: i18n.t("unitText.set"),
                icon: require("../../img/accets/gun-num.png"),
            },
            {
                name: i18n.t("homeData.bottomPower"),
                value: 0,
                key: "totalPower",
                unit: "kW",
                icon: require("../../img/accets/power-num.png"),
            },
        ];
    }
    getVisible2() {
        this.getHomeStatAssets();
    }
    selectChange() {
        this.type =
            this.type == AssetsType.TOTAL ? AssetsType.DETAIL : AssetsType.TOTAL;
    }
    async getHomeStatAssets() {
        const params = {
            oprPkId: this.oprPkId,
        };
        this.loading = true;
        const ret = await getHomeStatAssets(params);
        this.loading = false;
        if (ret.status === this.$config.apiStatus) {
            this.statAssets = ret.data[0];
        }
    }
    mounted() {
        this.getHomeStatAssets();
    }
};
__decorate([
    Prop({ default: "" })
], PiHomeDataBottom.prototype, "oprPkId", void 0);
__decorate([
    Watch("oprPkId")
], PiHomeDataBottom.prototype, "getVisible2", null);
PiHomeDataBottom = __decorate([
    Component({
        components: {
            "pi-home-data-block": homeDataBlock,
        },
    })
], PiHomeDataBottom);
export default PiHomeDataBottom;
